/*! one-spot — Voucher feedback controller.
 *
 * Shows a success modal (or invalid-code message) when a discount/voucher is
 * applied. Two triggers, one modal:
 *   1) URL flow  — gs-discount-redirect.liquid turns ?gs=CODE into Shopify's
 *      /discount/CODE and redirects back with ?gs_applied=CODE. We read that,
 *      check /cart.js, and show the result.
 *   2) Cart field — the theme's coupon input dispatches
 *      'maximize:cart:discount-code:change' on apply. We celebrate success
 *      (the cart field renders its own inline error for invalid codes).
 *
 * Shopify limitation: a code's value/validity is only visible once the cart has
 * applicable items. With an empty cart we show a soft confirmation (no amount),
 * since the code is still stored for checkout.
 */
(function () {
  var MODAL_ID = 'gsVoucher';
  var shown = new Set();

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function modal() { return document.getElementById(MODAL_ID); }
  function money(cents) { return '€ ' + (Number(cents || 0) / 100).toFixed(2).replace('.', ','); }

  function open(opts) {
    var m = modal();
    if (!m) return;
    m.classList.toggle('gs-voucher--error', !!opts.error);
    qs('.gs-voucher__heading', m).textContent = opts.heading || '';
    qs('[data-gs-code]', m).textContent = opts.code || '';
    qs('[data-gs-savings]', m).textContent = opts.savings || '';
    qs('[data-gs-cta]', m).textContent = opts.ctaLabel || 'JETZT SHOPPEN';
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    var m = modal();
    if (!m) return;
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Total savings (cents) + resolved code for a given attempted code (or any
     code-level discount when `code` is null). Sums cart-level + line-item. */
  function discountFor(cart, code) {
    var lc = code ? String(code).toLowerCase() : null;
    var cents = 0;
    var found = null;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (!lc || (d.title || '').toLowerCase() === lc) {
        cents += d.total_allocated_amount || 0;
        found = found || d.title;
      }
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var t = (al.discount_application && al.discount_application.title) || '';
        if (!lc || t.toLowerCase() === lc) {
          cents += al.amount || 0;
          found = found || t;
        }
      });
    });
    return { cents: cents, code: found };
  }

  function evaluate(code) {
    return fetchCart().then(function (cart) {
      var d = discountFor(cart, code);
      var eff = (code || d.code || '').toString();
      if (eff && shown.has(eff.toLowerCase())) return;
      if (d.cents > 0 || d.code) {
        if (eff) shown.add(eff.toLowerCase());
        open({
          heading: 'Der Gutschein wurde erfolgreich aktiviert!',
          code: eff.toUpperCase(),
          savings: money(d.cents) + ' Ersparnis'
        });
      } else if ((cart.item_count || 0) === 0 && code) {
        shown.add(code.toLowerCase());
        open({
          heading: 'Der Gutschein wurde aktiviert!',
          code: code.toUpperCase(),
          savings: 'wird an der Kasse angewendet'
        });
      } else if (code) {
        shown.add(code.toLowerCase());
        open({
          error: true,
          heading: 'Dieser Gutschein-Code ist leider ungültig.',
          code: code.toUpperCase(),
          savings: '',
          ctaLabel: 'Weiter shoppen'
        });
      }
    }).catch(function () { /* never block */ });
  }

  function init() {
    var m = modal();
    if (!m) return;

    m.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-gs-close')) close();
    });
    qs('[data-gs-cta]', m).addEventListener('click', function (e) { e.preventDefault(); close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.getAttribute('aria-hidden') === 'false') close();
    });

    // 1) URL flow — ?gs_applied=CODE set by gs-discount-redirect
    try {
      var p = new URLSearchParams(window.location.search);
      var code = (p.get('gs_applied') || '').trim();
      if (code) {
        p.delete('gs_applied');
        var rest = p.toString();
        history.replaceState({}, '', window.location.pathname + (rest ? '?' + rest : '') + (window.location.hash || ''));
        evaluate(code);
      }
    } catch (e) { /* ignore */ }

    // 2) Cart discount field — theme fires this on (successful) apply
    document.addEventListener('maximize:cart:discount-code:change', function () {
      setTimeout(function () {
        var store = window.Alpine && window.Alpine.store && window.Alpine.store('xCouponCodeDetail');
        if (store && store.discountFailed) return; // cart field shows its own inline error
        var codes = (store && store.appliedDiscountCodes) || [];
        evaluate(codes.length ? codes[codes.length - 1] : null);
      }, 350);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
